import {loginRedirect} from './../common/Util'

function validateResponse(response) {
    if (!response.ok) {
        if (response.status === 401) {
        	loginRedirect();
        } else {
            throw new Error("Unknown error occurred : " + response.statusText);
        }
    } else {
    	return response.json();
    }
}

export function getUser(getUserCallback) {
    console.log('in getUser');
    return fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/users/currentUser', {
      headers: {
        'Accept': 'application/json',
        },
        credentials: 'include'
        })
        .then(results=> {
            return validateResponse(results);
        })
        .then(data => {
            getUserCallback(data);
            return data;
        })
        .catch(error => {
            console.log('error trying to fetch current user : \n', error);
            window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
            return Promise.reject()
        })
  }



// WEBPACK FOOTER //
// ./src/firstnetSubscriberOnboarding/GetUser.js